module.exports = __webpack_public_path__ + "static/media/card-2.ae10829f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-2.jpeg
// module id = 573
// module chunks = 0